module.exports = __webpack_public_path__ + "img/wgzzs.c461ba8b.jpg";